import { ShippingOptionParcel } from '@pedix-workspace/utils';
import { ShippingCostRequest, ShippingCostResponse } from './delivery.types';

export async function calculateParcelShippingCost(
  shippingOptionParcel: ShippingOptionParcel,
  shippingCostRequest: ShippingCostRequest,
): Promise<ShippingCostResponse | null> {
  return {
    deliveryCost: 12345,
    shippingOption: shippingOptionParcel,
  };
  // if (shippingOptionParcel.quotationMethod === 'MANUAL') {
  //   return null;
  // }
  // return null;
}
